
import { AbstractControl } from '@angular/forms';
import {
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
  } from '@angular/forms';
 

  export function requireMyKadNo(firstControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
         
      var field = control.get(firstControl).value;
      field = control.get(firstControl).value.first+'-'+control.get(firstControl).value.middle+'-'+control.get(firstControl).value.end;
		if ((field.length >= 1 && field.length == 14)) {
            return null;	
        } else {
            return { requireMyKadNo: 'MyKad No. is required.' };
        } 
       
    };
  }

